<template>
    <div>

        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showconclusion">
            <v-card color="primary">
                <v-card-title class="card-title-style">
                    Agregar Movimiento
                </v-card-title>
            </v-card>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="loaded == true">
                        <v-col cols="12" md="7">
                            <div>
                                <span class="type-label-style">Tipo de Movimiento</span>
                                <p class="type-text-style">Impulsos Procesales</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>


                            <v-row class="my-4" justify="space-between">
                                <v-col cols="12" md="6">
                                    <span class="type-label-style">Fecha del movimiento:</span>
                                    <v-dialog ref="dialog" outlined v-model="modal" :return-value.sync="selectedDate" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="date-align-center">
                                                <v-text-field v-model="selectedDate" label="" readonly :rules="rulestextfechas" outlined dense v-bind="attrs" v-on="on"></v-text-field>
                                            </div>
                                        </template>
                                        <v-date-picker v-model="selectedDate" locale="es-mx" :max="maxDate" :min="minDate" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(selectedDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <span class="type-label-style">Monto:</span>
                                    <v-text-field v-model="monto" outlined dense :rules="rulesInputsNumber" @keypress="ruleMoney($event, monto)"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider class="mt-1"></v-divider>

                            <div class="mt-4">
                                <span class="type-label-style">Autoriza:</span>
                                <v-radio-group row v-model="autoriza" :rules="rulesRadio"
                                               inline style="margin: -1px; margin-left: 15px;">
                                    <v-radio label="Cliente" value="C"></v-radio>
                                    <v-radio label="Asegurado" value="A"></v-radio>
                                </v-radio-group>
                            </div>



                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">Nombre Autoriza:</span>
                                <v-text-field v-model="nombre" outlined dense :rules="rulesText" :maxlength="50"
                                              v-on:blur="nombre = nombre != null ? nombre.trim() : null"></v-text-field>

                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">¿Cómo autoriza?:</span>
                                <v-radio-group row v-model="tipo" :rules="rulesRadio"
                                               inline style="margin: -1px; margin-left: 15px;">
                                    <v-radio label="Llamada" value="LL"></v-radio>
                                    <v-radio label="Correo" value="CO"></v-radio>
                                    <v-radio label="Whatsapp" value="WP"></v-radio>
                                </v-radio-group>

                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">Motivo:</span>
                                <v-select outlined dense :items="motivoArray"
                                          v-model="motivo" item-text="label" item-value="value"
                                          placeholder="Seleccione Motivo" :rules="ruleSelect">

                                </v-select>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div class="mt-4">
                                <span class="type-label-style">Uso en:</span>
                                <v-radio-group row v-model="uso" :rules="rulesRadio"
                                               inline style="margin: -1px; margin-left: 15px;">
                                    <v-radio label="Crucero" value="CR"></v-radio>
                                    <v-radio label="MP" value="MP"></v-radio>
                                    <v-radio label="Guardia Nacional" value="GN"></v-radio>
                                    <v-radio label="Tránsito" value="TR"></v-radio>
                                </v-radio-group>

                            </div>
                            <v-divider class="mt-1"></v-divider>


                            <div class="mt-4">
                                <span class="type-label-style">Observaciones:</span>
                                <v-textarea id="textareaobs"
                                            v-on:blur="observaciones = observaciones != null ? observaciones.trim() : null"
                                            v-model="observaciones" class="mt-2 textarea" outlined
                                            hide-details :rules="rulestextarea" :maxlength="$store.state.maxLengthComentarios">
                                </v-textarea>
                                <v-row>
                                    <v-col>
                                        <span style="color: red">{{ obsError }}</span>
                                    </v-col>
                                    <v-col style="display: grid; place-items: end;">
                                        <span class="v-counter">{{ obsCounter }}/400</span>
                                    </v-col>

                                </v-row>
                            </div>

                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="loaded == true">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="ma-2" color="primary" title="Guardar" @click="guardar()"
                                   :disabled="disBtn">
                                <span style="color: white">Guardar</span>
                            </v-btn>

                            <v-btn color="#FF4081" v-on:click="limpiar()">
                                <span style="color: white">Limpiar</span>
                            </v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-row>

                </v-card-text>
            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card color="primary">
                <v-card-title class="card-title-style">
                    Movimientos
                </v-card-title>
            </v-card>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" md="12" >
                        <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                   :params="displayInputs" :order="[[0, 'desc']]" @apiDT="apiDT = $event" 
                                  ></DataTable>
                    </v-col>
                </v-row>

            </v-card-text>


        </v-card>
    </div>
</template>


<script>
    import General from "@/services/ReporteGeneral/ReporteGeneral.service.js";
    import { mapActions, mapMutations, mapState } from "vuex";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";
    export default {
        components: {
            DataTable
        },
        title() {
            return this.$route.meta.title
        },
        data: function () {
            return {
                showconclusion: false,
                apiDT: null,
                validForm: true,
                showcargando: true,
                loaded: false,

                obsError: "",
                obsCounter: "",            
                disBtn: false,
                modal: false,
                minDate: null,
                maxDate: null,

                selectedDate: "",
                monto: "",
                autoriza: "",
                nombre: "",
                tipo: "",
                motivo: "",
                observaciones: "",
                uso: "",

                datosReporte: null,
                motivoArray: [],

                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                },
                formatterActions: [
                ],
                urlListado: "ReporteGeneral/ObtenerMovimientosIMP",
                columns: [
                    { name: 'impfhalta', data: 'impfhalta', title: "Fecha" },
                    { name: 'impfhabo', data: 'impfhabo', title: "Fecha Abo" },
                    { name: 'impmonto', data: 'impmonto', title: "Monto" },
                    { name: 'impautoriza', data: 'impautoriza', title: "Autoriza" },
                    { name: 'impnombre', data: 'impnombre', title: "Nombre Autoriza" },
                    { name: 'imptipoautoriza', data: 'imptipoautoriza', title: "Tipo" },
                    { name: 'miconcepto', data: 'miconcepto', title: "Motivo" },
                    { name: 'impuso', data: 'impuso', title: "Uso" },
                    { name: 'impobs', data: 'impobs', title: "Observaciones" },
                    { name: 'uslogin', data: 'uslogin', title: "Usuario" },

                ],

                rulestextfechas: [(v) => !!v || "Campo requerido"],
                rulesRadio: [v => !!v || 'Seleccione alguna opción'],
                ruleSelect: [(v) => !!v || "Campo requerido"],
                rulesText: [
                    (v) => {
                        if (v == null || v == "") {
                            return "Campo requerido";
                        } else {
                            if (v.trim().length < 12) {
                                return "Mínimo 12 Carácteres";
                            } else if (v.trim().length > 50) {
                                return "Máximo 50 Carácteres";
                            } else {
                                return true;
                            }
                        }
                    },
                ],
                rulestextarea: [
                    (v) => {
                        if (v == null || v == "") {
                            return "Campo requerido";
                        } else {
                            if (v.trim().length < 12) {
                                return "Mínimo 12 Carácteres";
                            } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                                return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                            } else {
                                return true;
                            }
                        }
                    },
                ],
                rulesInputsNumber: [(v) => {
                    if (v == null || v == '') {
                        return 'Inserte un valor valido';
                    }
                    else {
                        if (v < 100 || v > 1000000) {
                            return 'El monto debe ser entre 100 y 1,000,000';
                        }
                        else
                            return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                    }
                    return true
                }],

            }
        },
        computed: {

            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
        watch: {
            observaciones(val) {
                if (val != "") {
                    this.obsError = "";


                }

                this.obsCounter = this.observaciones.length.toString();
            },
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            async guardar() {
                this.disBtn = true;
                if (
                    this.observaciones == null ||
                    this.observaciones == ""
                ) {
                    this.obsError = "Campo requerido";
                } else {
                    if (this.observaciones.trim().length < 12) {
                        this.obsError = "Mínimo 12 Carácteres";
                    } else if (this.observaciones.trim().length > this.$store.state.maxLengthComentarios) {
                        this.obsError = "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                    }
                }

                this.$refs.form.validate();
                if (this.$refs.form.validate()) {
                    this.$swal({
                        position: "center",
                        title: "Guardando...",
                        html: "Espere un momento por favor",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirm: false,
                    });
                    this.$swal.showLoading();

                    try {
                        let resp = await General.AgregarMovimientosImpulsosProcesales(this);

                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Éxito!",
                            html: "Movimiento guardado correctamente",
                            allowOutsideClick: false,
                            showConfirmButton: true,
                            timer: 3000,
                        })
                        this.reloadTable();
                        this.disBtn = false;
                        this.limpiar();
                    } catch (e) {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Algo salio mal",
                            html: "Algo salio mal, por favor intente de nuevo mas tarde",
                            allowOutsideClick: false,
                            showConfirmButton: true,
                        });
                    }

                   


                }
                else {
                    this.disBtn = false;
                }


            },
            limpiar() {

                this.obsError = "";
                this.obsCounter = "";

                let today = new Date().toJSON().slice(0, 10);
                this.selectedDate = today;

                this.monto = "";
                this.autoriza = "";
                this.nombre = "";
                this.tipo = "";
                this.motivo = "";
                this.observaciones = "";
                this.uso = "";

                this.$refs.form.resetValidation();
            },
            ruleMoney: function ($event, value) {
                if (value == '' || value == null) {
                    if ($event.charCode >= 49 && $event.charCode <= 57) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }
                else {
                    if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }

                }
            },
        },
        async mounted() {

            await MetodosGenerales.verificarPermisoSolo(
                this.domain.domainNameForApi,
                "VerificarPermiso",
                "389"
            ).then((response) => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch((error) => error);
                }
            });


            this.changeReporteMenuOption("Impulsos Procesales");
            let datos = await MetodosGenerales.obtenerSessionReporte("reporte");

            let response1 = await General.conclusionImpulsos(this, datos);

            let val = response1[0].Estatus;
            if (val == 1) {
                this.showconclusion = true;
            }
            else {
                this.showconclusion = false;
            }
            
            
            this.datosReporte = datos;
            this.displayInputs = {
                nrreporte: this.datosReporte.nrreporte,
                svindice: this.datosReporte.svindice
            };

            let today = new Date().toJSON().slice(0, 10);
            this.maxDate = today;
            this.selectedDate = today;


            let response = await General.fechaSvreporte(this, this.datosReporte);

            this.minDate = response[0]["svfhreporte"];



            this.motivoArray = await General.MotivosImpulsos(this);


            this.showcargando = false;
            

            setTimeout(() => {
                this.loaded = true;
            }, 2000);

        }
    }
</script>

<style scoped>
    .card-title-style {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1.1em;
        color: white;
    }
</style>